import React from 'react';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Method from '../components/sections/Method';
import Portfolio from '../components/sections/Portfolio';
import Team from '../components/sections/Team';
import Contact from '../components/sections/Contact';

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Method />
      <Portfolio />
      <Team />
      <Contact />
    </>
  );
};

export default Home;